/**
 * @generated SignedSource<<03f3d6f4d8e33c3fefc832e8d6f5d36f>>
 * @relayHash a10f96be3fe65a7cec20565dddb79d4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0e82c18757b62bce67f8c5cb586879ded746a1943caa80c59adf768e875a32f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LoomFeedListQuery$variables = {
  isEnabled: boolean;
  loomSiteAri: string;
};
export type LoomFeedListQuery$data = {
  readonly loom_workspaceTrendingVideos?: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LoomFeedCardFragment">;
  } | null> | null;
};
export type LoomFeedListQuery = {
  response: LoomFeedListQuery$data;
  variables: LoomFeedListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loomSiteAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "loomSiteAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "LoomFeedListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "LoomVideo",
            "kind": "LinkedField",
            "name": "loom_workspaceTrendingVideos",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "LoomFeedCardFragment"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoomFeedListQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "LoomVideo",
            "kind": "LinkedField",
            "name": "loom_workspaceTrendingVideos",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "picture"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "url"
              },
              {
                "kind": "ScalarField",
                "name": "playableDuration"
              },
              {
                "concreteType": "LoomVideoDefaultThumbnailsSources",
                "kind": "LinkedField",
                "name": "thumbnails",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "default"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "static"
                  }
                ]
              },
              {
                "concreteType": "LoomVideoViewCounts",
                "kind": "LinkedField",
                "name": "viewCounts",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "total"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "commentCount"
              },
              {
                "kind": "ScalarField",
                "name": "reactionCount"
              },
              {
                "kind": "ScalarField",
                "name": "createdAt"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a10f96be3fe65a7cec20565dddb79d4a",
    "id": "e0e82c18757b62bce67f8c5cb586879ded746a1943caa80c59adf768e875a32f",
    "metadata": {},
    "name": "LoomFeedListQuery",
    "operationKind": "query",
    "text": "query LoomFeedListQuery(\n  $loomSiteAri: ID!\n  $isEnabled: Boolean!\n) {\n  loom_workspaceTrendingVideos(id: $loomSiteAri) @include(if: $isEnabled) {\n    id\n    ...LoomFeedCardFragment\n  }\n}\n\nfragment LoomFeedCardFragment on LoomVideo {\n  id\n  name\n  owner {\n    __typename\n    name\n    picture\n    accountId\n    accountStatus\n    id\n  }\n  url\n  playableDuration\n  thumbnails {\n    default\n    static\n  }\n  viewCounts {\n    total\n  }\n  commentCount\n  reactionCount\n  createdAt\n}\n"
  }
};
})();

(node as any).hash = "facebbda706d015b725adf660830d9ea";

export default node;
